module.exports = __webpack_public_path__ + "img/accommodation_icon.eac4dc2e.svg";